<template>
    <AccordionContent
        v-bind="delegatedProps"
        class="overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
        <div :class="cn('pb-4 pt-0', props.class)">
            <slot />
        </div>
    </AccordionContent>
</template>
<script setup lang="ts">
import { AccordionContent, type AccordionContentProps } from "reka-ui";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<AccordionContentProps & { class?: HTMLAttributes["class"] }>();

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});
</script>
